import { SVG } from './SVG';
const IconYoutubeAlt1 = () => {
  return (
    <SVG width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.5401 7.08992C22.4213 6.61533 22.1794 6.18049 21.8387 5.82933C21.4981 5.47816 21.0708 5.22311 20.6001 5.08992C18.8801 4.66992 12.0001 4.66992 12.0001 4.66992C12.0001 4.66992 5.12008 4.66992 3.40008 5.12992C2.92933 5.26311 2.50206 5.51816 2.16143 5.86933C1.8208 6.22049 1.57887 6.65533 1.46008 7.12992C1.1453 8.87548 0.991319 10.6462 1.00008 12.4199C0.988863 14.207 1.14285 15.9912 1.46008 17.7499C1.59104 18.2098 1.83839 18.6281 2.17823 18.9644C2.51806 19.3007 2.9389 19.5437 3.40008 19.6699C5.12008 20.1299 12.0001 20.1299 12.0001 20.1299C12.0001 20.1299 18.8801 20.1299 20.6001 19.6699C21.0708 19.5367 21.4981 19.2817 21.8387 18.9305C22.1794 18.5793 22.4213 18.1445 22.5401 17.6699C22.8524 15.9375 23.0064 14.1803 23.0001 12.4199C23.0113 10.6329 22.8573 8.84862 22.5401 7.08992Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75008 15.6899L15.5001 12.4199L9.75008 9.14992V15.6899Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

export { IconYoutubeAlt1 as default, IconYoutubeAlt1 };
